import React, { useState } from 'react'
import PageHeader from '../../shared/PageHeader'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../shared/CustomButton'
import AddIcon from '@mui/icons-material/Add'
import { useNavigate } from 'react-router-dom'
import PayerTable from './PayerTable'
import TableLoader from '../../common/TableLoader'

function PayerManagement () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  return (
    <>
      {loading ? (
        <TableLoader
          columns={6}
          headerButtonsCount={1}
          showHeaderButtons={true}
          showTitle={true}
          showPagination={true}
        />
      ) : (
        <div className='superGit_container !p-0'>
          <PageHeader
            title={t('Payer Management')}
            subtitle
            tooltip={t('Keep track of your payers')}
            total={0}
            entriesLabel={t('Entries')}
          >
            <CustomButton
              label={t('Add New Payer')}
              icon={<AddIcon />}
              onClick={() => {
                navigate('/payer-managment/form')
              }}
            />
          </PageHeader>
          <div className='mt-3'>
            <PayerTable />
          </div>
        </div>
      )}
    </>
  )
}

export default PayerManagement
